export default "__VITE_ASSET__C_alZniQ__"